
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registration/questions",
      function () {
        return require("private-next-pages/registration/questions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/registration/questions"])
      });
    }
  